export default __webpack_public_path__ + "media/zurb/fonts/ProximaNova-Bold-26c2dcb865f4fe0396d3ca4cad9ea3fe.woff2";